import { useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useDispatch, useSelector } from "react-redux";
import { getPatientNotification } from "../../actions/dashboardAction";
import {
  acceptOrRejectPractitioner,
  getPendingPractitioners,
  getPractitionerList,
} from "../../actions/practitionerAction";
import { setActivePractitionerForProfile } from "../../actions/roleAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import {
  getUserDetail,
  setUsetDetailToLocalStorage,
  formatDate,
} from "../../utils/helper";
import history from "../../utils/history";
import { BUCKET_NAME } from "../../constants/states";
const PendingPractitioners = () => {
  const pendingPractitionerList = useSelector(
    (state) => state.practitioner.pendingPractitionerList
  );
  const role = useSelector((state) => state.role.role);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPendingPractitioners());
  }, [dispatch]);

  const togglePractitioner = (actionName, id) => {
    dispatch(
      acceptOrRejectPractitioner(actionName, id, () => {
        if (actionName == "patientAcceptsPractitioner") {
          var user = getUserDetail();
          user.user = {
            first_name: user.firstName,
            last_name: user.lastName,
          };
          user.isPractitionerConnected = true;
          setUsetDetailToLocalStorage(user);
          window.dispatchEvent(new Event("storage"));
        }
        dispatch(getPendingPractitioners());
        dispatch(getPractitionerList());
        dispatch(getPatientNotification(role.val));
      })
    );
  };

  const patientAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div className="action-btn-wrapper row">
          <button
            className="btn-orange btn-table "
            onClick={() => {
              togglePractitioner("patientAcceptsPractitioner", row.ppc_id);
            }}
          >
            Accept
          </button>

          <button
            className=" btn-orange btn-black  btn-table "
            onClick={() => {
              togglePractitioner("patientRejectsPractitioner", row.ppc_id);
            }}
          >
            Reject
          </button>
        </div>
      </>
    );
  };

  const profileAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <button
        className="profile-icon"
        onClick={() => {
          history.push("/app/practitioner/info");
          dispatch(setActivePractitionerForProfile(row.Practitioner_ID));
        }}
      >
        <img
          src={
            row.Has_Profile_Picture
              ? `https://storage.googleapis.com/${BUCKET_NAME}/user/${
                  row.user_id
                }.png?${Math.random()}`
              : Avatar
          }
          alt="icon"
        />{" "}
        <span>View</span>
      </button>
    );
  };

  const columns = [
    {
      dataField: "ppc_id",
      text: "Profile",
      sort: false,
      headerStyle: {
        width: "100px",
      },
      formatter: profileAction,
    },
    {
      dataField: "first_name",
      text: "First Name",
      sort: true,
    },
    {
      dataField: "last_name",
      text: "Last Name",
      sort: true,
    },
    {
      dataField: "clinic",
      text: "Clinic",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>{row.clinic_name}</p>
            <a style={{ color: "#f79225" }} href={row.clinic_url}>
              {row.clinic_url}
            </a>
          </>
        );
      },
    },
    {
      dataField: "requested_date",
      text: "Date Requested",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return formatDate(row.requested_date);
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: patientAction,
    },
  ];

  return (
    <div>
      <h5 className="profile-title mb-1">Pending Practitioners</h5>
      {pendingPractitionerList.length > 0 ? (
        <BootstrapTable
          classes="react-bootstrap-table"
          keyField="ppc_id"
          columns={columns}
          data={pendingPractitionerList}
          headerClasses="header-class"
        />
      ) : (
        <p className="page-desc">
          There are no pending practitioner requests at this time
        </p>
      )}
    </div>
  );
};

export default PendingPractitioners;
